<template>
  <div>
    <!-- CNC Ads -->
    <DefaultAdsCncWrapper
      v-if="props.cncAdsPage"
      :position="UniFeAdsPosition.ABOVE_HEADER"
      :page="props.cncAdsPage"
    />

    <!-- HEADER -->
    <DefaultHeader
      v-if="!props.hideHeader"
      :menu-items="props.menuItems"
    />

    <main
      :class="errorPage ? '' : 'main--error-page'"
      class="main branding-wrapper"

    >
      <!-- BREADCRUMBS -->
      <DefaultBreadcrumbs
        v-if="!props.hideBreadcrumbs"
        :text="props.breadcrumbText"
      />

      <!-- PAGE CONTENT -->
      <slot />
    </main>

    <!-- FOOTER -->
    <DefaultFooter
      v-if="!props.hideFooter"
    />
  </div>
</template>

<script setup lang="ts">
import {UniFeAdsPosition} from "~/libs/constants/UniFeAdsPosition"
import type {PropType} from "vue";
import {CncAdsPage} from "~/libs/constants/CncAdsPage"
import type StaticMenuItem from "~/libs/interfaces/StaticMenuItem"

const props = defineProps({
  cncAdsPage: {type: String as PropType<CncAdsPage>, required: false},
  menuItems: {type: Array as PropType<StaticMenuItem[]>, required: false, default: []},
  breadcrumbText: {type: String, required: false},
  hideHeader: {type: Boolean, required: false, default: false},
  hideBreadcrumbs: {type: Boolean, required: false, default: false},
  hideFooter: {type: Boolean, required: false, default: false},
  errorPage: {type: Boolean, required: false, default: false},
})
</script>